import React from "react";

/**
 * North-Indian Diamond Kundli Chart (SVG). Dark, thick grid lines.
 */
const SHORT = {
  Sun: "Su", Moon: "Mo", Mars: "Ma", Mercury: "Me", Jupiter: "Ju",
  Venus: "Ve", Saturn: "Sa", Rahu: "Ra", Ketu: "Ke",
};

const HOUSE_CENTERS = {
  1: { x: 200, y: 100, tw: 90 },
  2: { x: 100, y: 50,  tw: 70 },
  3: { x: 50,  y: 100, tw: 70 },
  4: { x: 100, y: 200, tw: 90 },
  5: { x: 50,  y: 300, tw: 70 },
  6: { x: 100, y: 350, tw: 70 },
  7: { x: 200, y: 300, tw: 90 },
  8: { x: 300, y: 350, tw: 70 },
  9: { x: 350, y: 300, tw: 70 },
  10:{ x: 300, y: 200, tw: 90 },
  11:{ x: 350, y: 100, tw: 70 },
  12:{ x: 300, y: 50,  tw: 70 },
};

export default function KundliChart({ kundli }) {
  if (!kundli) return null;
  const planetsByHouse = {};
  (kundli.planets || []).forEach((p) => {
    (planetsByHouse[p.house] = planetsByHouse[p.house] || []).push(p);
  });
  const houseSign = {};
  (kundli.houses || []).forEach((h) => { houseSign[h.house] = h.sign_index + 1; });

  return (
    <div className="flex justify-center">
      <svg viewBox="0 0 400 400" width="420" height="420"
           className="rounded-2xl bg-white dark:bg-slate-900 border-2 border-black dark:border-slate-100 shadow-xl"
           data-testid="kundli-chart">
        {/* outer square — thick, dark */}
        <rect x="2" y="2" width="396" height="396" fill="none" stroke="#0F172A" strokeWidth="4" />
        {/* two diagonals — thick, dark */}
        <line x1="0" y1="0" x2="400" y2="400" stroke="#0F172A" strokeWidth="3" />
        <line x1="400" y1="0" x2="0" y2="400" stroke="#0F172A" strokeWidth="3" />
        {/* inner diamond — thick, dark */}
        <polygon points="200,0 400,200 200,400 0,200" fill="none" stroke="#0F172A" strokeWidth="3" />

        {Object.entries(HOUSE_CENTERS).map(([h, c]) => {
          const planets = planetsByHouse[h] || [];
          const sign = houseSign[h];
          return (
            <g key={h}>
              {/* sign number (bigger + bolder + dark) */}
              <text x={c.x} y={c.y - 24} textAnchor="middle" fontSize="13" fill="#0F172A"
                    fontFamily="ui-monospace, monospace" fontWeight="900">
                {String(sign)}
              </text>
              {/* planets (bigger + bolder, BLACK) */}
              {planets.map((p, i) => (
                <text
                  key={p.name}
                  x={c.x}
                  y={c.y - 2 + i * 15}
                  textAnchor="middle"
                  fontSize="15"
                  fontWeight="900"
                  fill={p.retrograde ? "#B45309" : "#0F172A"}
                  fontFamily="ui-monospace, monospace"
                >
                  {`${SHORT[p.name] || p.name.slice(0,2)}${p.retrograde ? "℞" : ""}`}
                </text>
              ))}
            </g>
          );
        })}

        {/* Ascendant marker on house 1 */}
        <text x="200" y="32" textAnchor="middle" fontSize="11" fill="#DC2626"
              fontFamily="ui-monospace, monospace" fontWeight="900" letterSpacing="2">
          ★ LAGNA
        </text>
      </svg>
    </div>
  );
}
